export default {
    'please-select-a-filter': 'رجاءً قم باختيار أحد الفلاتر',
    customers: 'العملاء',
    'external-entities': 'الجهات الخارجية',
    staff: 'طاقم العمل',
}